import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Spinner from "../components/Spinner";

function TeamAuth() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("login");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);

  const [loginForm, setLoginForm] = useState({ email: "", phone: "" });
  const [regForm, setRegForm] = useState({
    county: "",
    coachName: "",
    phone: "",
    email: "",
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoggingIn(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/teams/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(loginForm),
        },
      );
      const data = await res.json();
      if (res.ok) {
        navigate("/coach", { state: { teams: data } });
      } else {
        setError(
          "No account found with that email and phone. Would you like to register instead?",
        );
      }
    } catch (err) {
      setError("Could not reach server");
    } finally {
      setLoggingIn(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setChecking(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/teams/check-exists`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: regForm.email,
            phone: regForm.phone,
          }),
        },
      );
      const data = await res.json();

      if (data.exists) {
        setError("You are already registered. Please log in instead.");
        setTab("login");
        setLoginForm({ email: regForm.email, phone: regForm.phone });
      } else {
        navigate("/confirm", { state: { team: regForm } });
      }
    } catch (err) {
      setError("Could not reach server");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-5 w-full max-w-sm">
        <h1 className="text-xl font-bold text-brand-red text-center mb-4">
          NextGen Diani CBO
        </h1>

        <div className="flex mb-4 border rounded-lg overflow-hidden">
          <button
            onClick={() => {
              setTab("login");
              setError("");
            }}
            className={`flex-1 py-2 font-semibold ${tab === "login" ? "bg-brand-red text-white" : "bg-gray-100 text-gray-600"}`}
          >
            Login
          </button>
          <button
            onClick={() => {
              setTab("register");
              setError("");
            }}
            className={`flex-1 py-2 font-semibold ${tab === "register" ? "bg-brand-red text-white" : "bg-gray-100 text-gray-600"}`}
          >
            Register
          </button>
        </div>

        {tab === "login" ? (
          <form onSubmit={handleLogin} className="space-y-3">
            <p className="text-sm text-gray-500 text-center">
              Enter your registered email and phone number
            </p>
            <input
              type="email"
              placeholder="Email"
              value={loginForm.email}
              onChange={(e) =>
                setLoginForm({
                  ...loginForm,
                  email: e.target.value.toLowerCase(),
                })
              }
              autoCapitalize="none"
              autoCorrect="off"
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={loggingIn}
              required
            />
            <input
              placeholder="Phone Number"
              value={loginForm.phone}
              onChange={(e) =>
                setLoginForm({ ...loginForm, phone: e.target.value })
              }
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={loggingIn}
              required
            />
            {error && <p className="text-red-600 text-sm">{error}</p>}
            {loggingIn ? (
              <Spinner />
            ) : (
              <button
                type="submit"
                className="w-full bg-brand-red text-white font-bold py-2.5 rounded-lg hover:bg-red-800"
              >
                Login
              </button>
            )}
          </form>
        ) : (
          <form onSubmit={handleRegister} className="space-y-3">
            <p className="text-sm text-gray-500 text-center">
              Register as a coach. You will choose your team categories after
              signing up.
            </p>
            <input
              placeholder="Coach / Manager Name"
              value={regForm.coachName}
              onChange={(e) =>
                setRegForm({ ...regForm, coachName: e.target.value })
              }
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={checking}
              required
            />
            <input
              placeholder="County / Area"
              value={regForm.county}
              onChange={(e) =>
                setRegForm({ ...regForm, county: e.target.value })
              }
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={checking}
              required
            />
            <input
              placeholder="Phone Number"
              value={regForm.phone}
              onChange={(e) =>
                setRegForm({ ...regForm, phone: e.target.value })
              }
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={checking}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={regForm.email}
              onChange={(e) =>
                setRegForm({ ...regForm, email: e.target.value.toLowerCase() })
              }
              autoCapitalize="none"
              autoCorrect="off"
              className="w-full border rounded-lg p-2.5 text-base"
              disabled={checking}
              required
            />
            {error && <p className="text-red-600 text-sm">{error}</p>}
            {checking ? (
              <Spinner />
            ) : (
              <button
                type="submit"
                className="w-full bg-brand-red text-white font-bold py-2.5 rounded-lg hover:bg-red-800"
              >
                Continue
              </button>
            )}
          </form>
        )}
      </div>

      <div className="fixed bottom-4 left-4">
        <Link
          to="/admin"
          className="flex items-center gap-2 bg-white text-brand-red font-semibold text-sm px-4 py-2 rounded-full shadow-lg border border-brand-red hover:bg-brand-cream transition"
        >
          Admin Login
        </Link>
      </div>
    </div>
  );
}

export default TeamAuth;